<template>
    <div>
        <buttonlist @help="help" ref="SetBtn" @reflash="reflash" @save="save"></buttonlist>
        <div style="display: flex">
            <div style="width:55%">
                <!--<el-button type="primary" size="mini" @click="countPlan(0)" :disabled="!btn.mnuMPS">{{$t('getapi[7203]')}}</el-button>-->
                <el-button type="primary" size="mini" @click="countMRP(0)" :disabled="!btn.mnuMRP">{{$t('getapi[7204]')}}</el-button>
                <el-button type="primary" size="mini" @click="updatePlanSetting()">{{$t('getapi[7205]')}}</el-button>
                <el-button type="primary" size="mini" @click="updateRouting()">{{$t('getapi[8193]')}}</el-button>
                <!--<el-button type="primary" size="mini" @click="getPlanStatus">获取计算状态</el-button>-->
                <el-button type="primary" size="mini" @click="stopMRB()" :disabled="!btn.stopMRB">{{$t('getapi[12662]')}}</el-button>
                <div style="margin-top: 10px">
                    <table class="tab">
                        <tr>
                            <span>{{$t('getapi[7187]')}}：{{dataDetail.statusstarttime}}</span>
                        </tr>
                        <tr>
                            <span>{{$t('getapi[7206]')}}：{{datetime}}</span>
                        </tr>
                        <tr>
                            <span>{{$t('getapi[7207]')}}：{{dataDetail.statusinfo}}</span>
                        </tr>
                        <tr>
                            <span>{{$t('getapi[7188]')}}：{{dataDetail.statusstatistic}}</span>
                        </tr>
                        <!--<tr>
                            <span>{{$t('getapi[7208]')}}{{dataDetail.statuscur}}</span>
                        </tr>-->
                        <tr>
                            {{$t('getapi[7208]')}}：<span v-html="dataDetail.statuscur"></span>
                        </tr>
                    </table>
                </div>
            </div>
            <div style="width:15%">
                <el-collapse  v-model="activeNames2">
                    <el-collapse-item :title="$t('getapi[7209]')" name="2">
                        <el-table
                                :data="dataSet.CargoLists"
                                border
                                :height="tableHeight"
                                header-row-class-name="headerclass"
                                size="mini"
                                style="padding: 2px">
                            <el-table-column width="80px" prop="config_langid" :label="$t('getapi[3596]')">
                                <template slot-scope="scope">
                                      <span v-if="scope.row.config_langid != '' && scope.row.config_langid != null">
                                         {{$t(`getapi[${scope.row.config_langid}]`)}}
                                    </span>
                                    <span v-else>
                                        {{scope.row.config_name}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config_value" :label="$t('getapi[3192]')">
                                <template slot-scope="scope">
                                    <fragment v-if="scope.row.remark == 'bit'">
                                        <el-select clearable v-model="scope.row.config_value" popper-class="select-option" size="mini" style="width:100%">
                                            <el-option :label="$t('getapi[561]')" :value="'1'"></el-option>
                                            <el-option :label="$t('getapi[866]')" :value="'0'"></el-option>
                                        </el-select>
                                    </fragment>
                                    <fragment v-if="scope.row.remark == 'datetime'">
                                        <el-date-picker v-model="scope.row.config_value" type="date" size="mini" style="width:100%"></el-date-picker>
                                    </fragment>
                                    <fragment v-if="scope.row.remark == 'char'">
                                        <el-input type="text" v-model="scope.row.config_value" style="width:100%"></el-input>
                                    </fragment>
                                    <fragment v-if="scope.row.remark == 'int'">
                                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.config_value" style="width:100%"></el-input>
                                    </fragment>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div style="width:1%"></div>
            <div style="width:25%">
                <el-collapse  v-model="activeNames">
                    <el-collapse-item title="MRP" name="1">
                        <el-table
                                :data="dataSet.MrpLists"
                                border
                                :height="tableHeight"
                                header-row-class-name="headerclass"
                                size="mini"
                                style="padding: 2px">
                            <el-table-column width="140px" prop="config_langid" :label="$t('getapi[3596]')">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.config_langid != '' && scope.row.config_langid != null">
                                         {{$t(`getapi[${scope.row.config_langid}]`)}}
                                    </span>
                                    <span v-else>
                                        {{scope.row.config_name}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config_value" :label="$t('getapi[3192]')">
                                <template slot-scope="scope">
                                    <fragment v-if="scope.row.remark == 'bit'">
                                        <el-select clearable v-model="scope.row.config_value" size="mini" style="width:100%">
                                            <el-option :label="$t('getapi[2052]')" :value="'1'"></el-option>
                                            <el-option :label="$t('getapi[2053]')" :value="'0'"></el-option>
                                        </el-select>
                                    </fragment>
                                    <fragment v-if="scope.row.remark == 'datetime'">
                                        <el-date-picker v-model="scope.row.config_value" type="date" size="mini" style="width:100%"></el-date-picker>
                                    </fragment>
                                    <fragment v-if="scope.row.remark == 'char'">
                                        <el-input type="text" v-model="scope.row.config_value" style="width:100%"></el-input>
                                    </fragment>
                                    <fragment v-if="scope.row.remark == 'int'">
                                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.config_value" style="width:100%"></el-input>
                                    </fragment>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>

        <el-dialog v-dialogDrag :visible.sync="visTips3" :title="titleTips3" width="25%" :close-on-click-modal="false" >
            <el-table
                    ref="singleTable"
                    header-row-class-name="headerclass"
                    stripe
                    :data="dataDetailTips3.DataList"
                    border
                    height="470"
                    size="mini"
                    :highlight-current-row="true"
                    style="width: 100%;"
            >
                <el-table-column
                        v-for="(item, i) in dataDetailTips3.ColumnsList"
                        :key="i"
                        show-overflow-tooltip
                        :prop="item.ColumnsField"
                        :label="item.ColumnsName"
                ></el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visTips3 = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="countPlan(3)">{{$t('getapi[7210]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visTipsMRP" :title="titleTipsMRP" width="25%" :close-on-click-modal="false" >
            <el-table
                    ref="singleTable"
                    header-row-class-name="headerclass"
                    stripe
                    :data="dataDetailTipsMRP.DataList"
                    border
                    height="470"
                    size="mini"
                    :highlight-current-row="true"
                    style="width: 100%;"
            >
                <el-table-column
                        v-for="(item, i) in dataDetailTipsMRP.ColumnsList"
                        :key="i"
                        show-overflow-tooltip
                        :prop="item.ColumnsField"
                        :label="item.ColumnsName"
                ></el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visTipsMRP = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="countMRP(3)">{{$t('getapi[7210]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visCalculated" width="10%" :close-on-click-modal="false" >

            <tr>
                <td>{{$t('getapi[6431]')}}</td>
            </tr>
            <!-- <tr>
                <td>{{$t('getapi[7273]')}}{{dataDetail.statusstarttime}}</td>
            </tr>
            <tr>
                <td>{{$t('getapi[7274]')}}{{dataDetail.statusendtime}}</td>
            </tr> -->

            <span slot="footer" class="dialog-footer">
				<el-button type="primary" size="mini" @click="visCalculated = false">{{$t('getapi[2051]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :title="$t('getapi[194]')" :visible.sync="visTipsMRP2" width="25%">
            <div style="height:300px">
                <span v-html="contentTipsMRP2"></span>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visTipsMRP2 = false">{{ $t('getapi[2054]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_mrpcount',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-280
            }
        },
        data() {
            return {
                datetime: '', // 当前时间
                begindatetime: '',
                enddatetime: '',
                dataDetail: {
                    istatus: '0',
                    statusinfo: '',
                    statuspartcode: '',
                    statuspartversion: '',
                    statuscur: '',
                    statusendtime: '',
                    statusstatistic: '',
                    statusstarttime: ''
                },
                dataSet:{
                    CargoLists: [],
                    MrpLists: []
                },
                oldDataSet: {
                    CargoLists: [],
                    MrpLists: []
                },
                activeNames: ['1'],
                activeNames2: ['2'],
                visTips3: false,
                titleTips3: '',
                dataDetailTips3: [],
                visTipsMRP: false,
                titleTipsMRP: '',
                visTipsMRP2: false,
                contentTipsMRP2:'',
                dataDetailTipsMRP: [],
                btn: {
                    mnuMPS: true,
                    mnuMRP: true,
                    mnuParamConfig: true,
                    stopMRB: false,
                },
                visCalculated: false,
                getPlanStatus: null,
                servertime: '',
                user: '',
            };
        },
        beforeDestroy(){
            console.log('关闭')
            clearInterval(this.getPlanStatus)
            this.getPlanStatus = null
        },
        mounted: function () {
            let that = this;
            that.user = JSON.parse(sessionStorage.getItem('userData')).username
            that.$http.urlpost('/MRP/Tool/GetMRPStatus', '', function (res) {
                if (res.Success == 1) {
                    that.dataDetail = res.DataContent
                    if(!that.$limits.fnIsEmpty(that.dataDetail.statuscur)){
                        that.dataDetail.statuscur = that.dataDetail.statuscur.replace("开始时间","<br/>开始时间").replace("结束时间","<br/>结束时间")
                    }
                    if(!that.$limits.fnIsEmpty(that.dataDetail.statusstarttime)){
                        let begindate = new Date(that.dataDetail.statusstarttime)
                        let enddate = new Date()
                        if((enddate - begindate) / (1000 * 60 ) > 30 && that.dataDetail.person == that.user){
                            that.btn.stopMRB = true
                        } else {
                            that.btn.stopMRB = false
                        }
                        that.getStatus()
                    }
                    console.log(that.dataDetail.statuscur)
                    that.btnauthority()
                }
            });
            that.getDateTime()
            that.getView()
            that.authority()
            //that.getPlanStatus()
            /*that.getPlanStatus = setInterval(() => {
                that.$http.urlpost('/MRP/Tool/GetMRPStatus', '', function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent
                        that.btnauthority()
                    }
                });
            }, 1000);*/
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6595]"),'MRP');
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                // //只读权
                that.$refs.SetBtn.SetButtonEnable('refresh');
                if(that.$limits.authority('plv2', 385, 1) > 1){
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                } else {
                    that.$refs.SetBtn.SetOneBtnEnable('save', false);
                }
            },
            btnauthority(){
                let that = this
                that.btn.mnuMPS = true
                that.btn.mnuMRP = true
                if(that.dataDetail.istatus == '0'){
                    that.executeLV2()
                }else{
                    if (that.$limits.authority('plv2', 159, 1) == 2) {
                        that.btn.mnuMPS = false
                        that.btn.mnuMRP = false
                    }

                    if (that.$limits.authority('plv2', 384, 1) == 2) {
                        that.btn.mnuMPS = false
                    }

                }
            },
            executeLV2(){
                let that = this
                let s = that.$limits.authority('plv2', 159, 1)
                switch (s)
                {
                    case 0:
                        that.btn.mnuMPS = false;
                        that.btn.mnuMRP = false;
                        break;
                    case 1:
                        that.btn.mnuMPS = false;
                        that.btn.mnuMRP = false;
                        break;
                    case 2:
                        that.btn.mnuMPS = true;
                        that.btn.mnuMRP = true;
                        break;
                }
                s = 0;
                s = that.$limits.authority('plv2', 384, 1)
                switch (s)
                {
                    case 0:
                        that.btn.mnuMPS = false;
                        break;

                    case 1:
                        that.btn.mnuMPS = false;
                        break;

                    case 2:
                        that.btn.mnuMPS = true;
                        break;
                }

                /*s = 0;
                s = that.$limits.authority('plv2', 385, 1)
                switch (s)
                {
                    case 0:
                        that.$refs.SetBtn.SetOneBtnEnable('save', false);
                        break;
                    case 1:
                        that.$refs.SetBtn.SetOneBtnEnable('save', false);
                        break;
                    case 2:
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
                        break;
                }*/

            },
            getDateTime() {
                let that = this;
                setInterval(function () {
                    let time = new Date();  // 程序计时的月从0开始取值后+1
                    let m = time.getMonth() + 1;
                    that.datetime = time.getFullYear() + "-" + m + "-"
                        + time.getDate() + " " + time.getHours() + ":"
                        + time.getMinutes() + ":" + time.getSeconds();
                }, 1000);
            },
            countPlan(val) {
                let that = this
                let parm = {
                    iscontinue: val,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/MRP/Tool/GetMPS', parm, function (res) {
                    if (res.Success == 1) {
                        that.visTips3 = false

                    } else if(res.Success == 2){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.countPlan(2)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    } else if(res.Success == 3){
                        that.visTips3 = true
                        that.titleTips3 = that.$processdata.explainCallbackMsg(res.Msg)
                        that.dataDetailTips3 = res.DataContent
                    }
                });
                setTimeout(() => {
                    /*if(val == 2 && that.visTips3 == false){
                        console.log('执行2')
                        that.getStatus()
                    } else if(val == 3){
                        console.log('执行3')
                        that.getStatus()
                    } else {
                        console.log('执行1')
                    }*/
                    that.getStatus()
                }, 5000);
            },
            countMRP(val) {
                let that = this
                let parm = {
                    iscontinue: val,
                    LangType: that.$processdata.getLang(),
                }
                if(val==3){
                    that.visTipsMRP=false;
                    that.btn.mnuMRP=false;
                    that.btn.mnuMPS=false;                    
                }
                that.$http.urlpost('/MRP/Tool/GetMRPCheck', parm, function (res) {
                    if (res.Success == 1) {
                        let parm1 = {
                            iscontinue: 0,
                            LangType: that.$processdata.getLang(),
                        }
                        that.$http.urlpost('/MRP/Tool/GetMRPCalc', parm1, function (res) {
                        });
                        setTimeout(() => {
                            that.getStatus()
                        }, 5000);
                    } else if(res.Success == 2){
                        that.getServerDate()
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.countMRP(2)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    } else if(res.Success == 3){
                        that.visTipsMRP = true
                        that.titleTipsMRP = that.$processdata.explainCallbackMsg(res.Msg)
                        that.dataDetailTipsMRP = res.DataContent
                    } else if(res.Success == 4){
                        that.visTipsMRP2 = true
                        that.contentTipsMRP2 = that.$processdata.explainCallbackMsg(res.Msg)
                        that.btn.mnuMRP=true;
                    } else{
                        that.btn.mnuMRP=false;
                    }
                });
            },
            getServerDate(){
                let that = this
                that.$http.urlpost('/MRP/Tool/GetServerTime', '', function (res) {
                    if (res.Success == 1) {
                        that.servertime = res.DataContent
                    }
                });
            },
            getStatus(){
                let that = this
                console.log(that.servertime)
                if(that.getPlanStatus !== null) {
                    return
                }
                that.getPlanStatus = setInterval(() => {
                    that.$http.urlpost('/MRP/Tool/GetMRPStatus', '', function (res) {
                        if (res.Success == 1) {
                            that.dataDetail = res.DataContent
                            if(!that.$limits.fnIsEmpty(that.dataDetail.statuscur)){
                                that.dataDetail.statuscur = that.dataDetail.statuscur.replace("开始时间","<br/>开始时间").replace("结束时间","<br/>结束时间")
                            }
                            that.btnauthority()
                            if(that.strDateTime(that.dataDetail.remark)){
                                if(that.dataDetail.istatus == 0 && (that.servertime < that.dataDetail.remark)){
                                    that.visCalculated = true
                                    clearInterval(that.getPlanStatus)
                                    that.getPlanStatus = null
                           /*         that.$http.urlpost("MRP/Tool/MRPSendMail", {}, function (res) {
                                        if (res.Success == 1) {
                                            console.log('发送邮件')
                                        }
                                    });*/
                                }
                            }
                            if(that.$limits.fnIsEmpty(that.dataDetail.statusstarttime)){
                                clearInterval(that.getPlanStatus)
                                that.getPlanStatus = null
                            }
                            let begindate = new Date(that.dataDetail.statusstarttime)
                            let enddate = new Date()
                            if((enddate - begindate) / (1000 * 60 ) > 30 && that.dataDetail.person == that.user){
                                that.btn.stopMRB = true
                            } else {
                                that.btn.stopMRB = false
                            }
                        }
                    });
                }, 5000);
            },
            stopMRB(){
                let that = this
                this.$confirm(that.$t('getapi[12663]'), that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.$http.urlpost('/MRP/Tool/StopMrp', '', function (res) {
                            if (res.Success == 1) {
                                that.btn.stopMRB = false
                            }
                        })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            getView() {
                let that = this
                that.$http.urlpost('/MRP/Tool/GetMrpConfig', '', function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent
                        that.oldDataSet = JSON.stringify(that.dataSet)
                    }
                });
                that.$http.urlpost('/MRP/Tool/GetMRPStatus', '', function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent
                        if(!that.$limits.fnIsEmpty(that.dataDetail.statuscur)){
                            that.dataDetail.statuscur = that.dataDetail.statuscur.replace("开始时间","<br/>开始时间").replace("结束时间","<br/>结束时间")
                        }
                        that.btnauthority()
                        if(that.$limits.fnIsEmpty(that.dataDetail.statusstarttime)){
                            let begindate = new Date(that.dataDetail.statusstarttime)
                            let enddate = new Date()
                            if((enddate - begindate) / (1000 * 60 ) > 30 && that.dataDetail.person == that.user){
                                that.btn.stopMRB = true
                            } else {
                                that.btn.stopMRB = false
                            }
                        }

                    }
                });
            },
            reflash(){
                let that = this
                that.getView()
            },
            save(){
                let that = this
                let data = JSON.parse(that.oldDataSet)
                let parm = {
                    CargoLists: that.dataSet.CargoLists,
                    MrpLists: that.dataSet.MrpLists,
                    OldCargoLists: data.CargoLists,
                    OldMrpLists: data.MrpLists,
                }
                that.$http.urlpost('/MRP/Tool/SaveMrpConfig', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            updatePlanSetting(){
                let that = this
                that.$http.urlpost('/MRP/Tool/UpdatePlanSetting', '', function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            //
            updateRouting(){
                let that = this
                that.$http.urlpost('/MRP/Tool/UpdateRoutingLeadTime', '', function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            // 判断时间格式
            strDateTime(str)
            {
                let reg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;
                let r = str.match(reg);
                if(r==null)return false;
                let d= new Date(r[1], r[3]-1,r[4],r[5],r[6],r[7]);
                return (d.getFullYear()==r[1]&&(d.getMonth()+1)==r[3]&&d.getDate()==r[4]&&d.getHours()==r[5]&&d.getMinutes()==r[6]&&d.getSeconds()==r[7]);
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .tab{
        border-spacing: 20px;
        font-size: 18px;
    }
    .el-table--mini, .el-table--small, .el-table__expand-icon{
        border: 1px solid #9cc1f5
    }
</style>
